// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getFeaturedProducts } from "@bg/App/Services/FeaturedProductsService";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import {
    chain,
    LoadFeaturedCategory,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

export const LoadSuggestedProducts: any = (props: any) => {
    const {
        parameter: { carouselType, isProductDetailsPage, numberOfProductsToDisplay, productId },
    } = props;

    if (carouselType !== "suggestedProducts" || !productId) {
        return;
    }

    if (!isProductDetailsPage) {
        return;
    }

    props.getProductCollectionParameter = {
        pageSize: numberOfProductsToDisplay,
        productId,
        relationship: "RequiredSuggestedNext",
    };
};

export const DispatchBeginLoadFeaturedProducts = (props: any) => {
    props.dispatch({
        type: "xFeaturedProducts/BeginLoadFeaturedProducts",
    });
};

export const RequestDataFromApi = async (props: any) => {
    if (props.parameter.carouselType !== "featuredProducts") {
        return;
    }
    DispatchBeginLoadFeaturedProducts(props);
    let featuredLoaded = false;
    const response = await getFeaturedProducts({
        pageSize: props.parameter.numberOfProductsToDisplay,
        pageNumber: props.parameter.pageNumber,
    });

    // the old ids are used for BGS & BP shopByLook page featured products,
    // keeping the ootb behavior and keeping the old products in the store to prevent them from being overwritten
    if (response) {
        featuredLoaded = true;

        props.dispatch({
            type: "xFeaturedProducts/TotalFeaturedItems",
            totalItems: response.featuredProducts?.rowCount || 0,
        });
        const newIds = response.featuredProducts?.data?.map(p => p.id) || [];
        props.apiResult = response.featuredProducts?.data;
        const productIds = [...newIds];

        props.getProductCollectionParameter = {
            productIds,
            pageSize: props.parameter.numberOfProductsToDisplay,
        };
    }

    waitFor(() => featuredLoaded);
};

export const DispatchCompleteLoadFeaturedProducts = (props: any) => {
    props.dispatch({
        type: "xFeaturedProducts/CompleteLoadFeaturedProducts",
    });
};

export const XngLoadProducts = (props: any) => {
    const {
        dispatch,
        getProductCollectionParameter,
        extraProductCollectionParameter,
        additionalSort,
        parameter: {
            carouselId,
            carouselType,
            numberOfProductsToDisplay,
            isProductDetailsPage,
            productId,
            isShellEdit,
        },
    } = props;
    if (!getProductCollectionParameter?.productIds && carouselType === "featuredProducts") {
        return;
    }

    if (!getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = extraProductCollectionParameter
        ? {
              getProductCollectionParameter: extraProductCollectionParameter,
              numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP = carouselType === "recentlyViewed" && isProductDetailsPage;

    dispatch(
        loadProductInfoList({
            id: carouselId,
            getProductCollectionParameter,
            extraProductOptions,
            excludeProductId: isRecentlyViewedOnPDP ? productId : undefined,
            forceLoad: isRecentlyViewedOnPDP,
            isShellEdit,
            additionalSort,
        } as any),
    );
    DispatchCompleteLoadFeaturedProducts(props);
};

addToChainAfter(chain, LoadFeaturedCategory, LoadSuggestedProducts);
replaceInChain(chain, LoadProducts, XngLoadProducts);
addToChainBefore(chain, XngLoadProducts, RequestDataFromApi);
